import {
	TFileId,
	ICreateSubCategoryValidationError,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	IServerError,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ISubCategoryAllDishes,
	IUpdateSubCategory,
} from 'types';
import { TVisibleForm, TTypeOfModalWindow, IInitialFormData } from './editSubCategoryContext';

export enum EditSubCategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_SUBCATEGORY = 'CHANGE_NAME_OF_SUBCATEGORY',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE = 'SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE',
	SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION = 'SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditSubCategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditSubCategoryActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditSubCategoryActionTypes.SET_ALL_DATA;
	payload: {
		filePath: Nullable<string>;
		preSignedUrl: string | null;
		initialIDSelectedCategory: Nullable<string>;
		initialNameSelectedCategory: Nullable<string>; // If they make category selection active then remove that.
		subCategoryID: string;
		initialIDSelectedCustomer: Nullable<string>;
		initialIDsSelectedRestaurant: string[];
		nameOfSubCategory: string;
		initialIDsOfRestaurantsWhereToHide: string[];
		initialIDsOfRestaurantsAvailableForRepetition: string[];
		dishesOfSubcategory: ISubCategoryAllDishes[];
		activationSchedule: string;
		deactivationSchedule: string;
		translations: IMenuTranslation[];
	};
}

interface IChangeLoaderStatus {
	type: EditSubCategoryActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: boolean;
	};
}

interface IChangeVisibleForm {
	type: EditSubCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFileId {
	type: EditSubCategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface IDeletePhoto {
	type: EditSubCategoryActionTypes.DELETE_PHOTO;
}

interface ISetFetchedCustomers {
	type: EditSubCategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetIDCustomer {
	type: EditSubCategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: EditSubCategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfoWithStatus[];
	};
}

interface ISetIDsRestaurant {
	type: EditSubCategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: string[];
		IDsOfRestaurantsWhereToHide: string[];
		IDsOfRestaurantsAvailableForRepetition: string[];
	};
}

interface IChangeNameOfSubCategory {
	type: EditSubCategoryActionTypes.CHANGE_NAME_OF_SUBCATEGORY;
	payload: {
		nameOfSubCategory: string;
	};
}

interface ISetFetchedCategories {
	type: EditSubCategoryActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		categories: IItemForGetShortInfo[];
	};
}

interface ISetIDCategory {
	type: EditSubCategoryActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: Nullable<string>;
	};
}

interface ISetIDsOfRestaurantsWhereToHide {
	type: EditSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE;
	payload: {
		IDsOfRestaurantsWhereToHide: string[];
	};
}

interface ISetIDsOfRestaurantsAvailableForRepetition {
	type: EditSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION;
	payload: {
		IDsOfRestaurantsAvailableForRepetition: string[];
	};
}

interface IChangeActivationSchedule {
	type: EditSubCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: string;
	};
}

interface IChangeDeactivationSchedule {
	type: EditSubCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: string;
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditSubCategoryActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: EditSubCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: EditSubCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: EditSubCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateSubCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditSubCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: EditSubCategoryActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<ICreateSubCategoryValidationError> | null;
	};
}

interface IResetSelectedControls {
	type: EditSubCategoryActionTypes.RESET_FIELDS;
}

export type TEditSubCategoryAction =
	| IRefetchData
	| ISetInitialFormData
	| IChangeLoaderStatus
	| ISetAllData
	| IChangeVisibleForm
	| ISetFileId
	| IDeletePhoto
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IChangeNameOfSubCategory
	| ISetFetchedCategories
	| ISetIDCategory
	| ISetIDsOfRestaurantsWhereToHide
	| ISetIDsOfRestaurantsAvailableForRepetition
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
